import EmailRequestDTO from "@/dto/EmailRequestDTO";
import {BASE_API_URL} from "@/config/env";
import {
    GetGeneralListSuccessResult, GetGeneralSuccessResult, GetSingleItemResult
} from "@/service/api/types/ApiResponseTypes";
import UserTag from "@/dto/UserTag";
import ApiService from "@/service/api/ApiService";
import axios, {AxiosResponse} from "axios";

export default class NotificationApiService extends ApiService{

    public async sendNotification(emailRequestDTO: EmailRequestDTO): Promise<GetSingleItemResult<string>> {
        const data = JSON.stringify(emailRequestDTO);
        return this.handlePostRequestReturningItem(
            `${BASE_API_URL}/email/notify`,
            data,
            {'Content-Type': 'application/json'},
            'send notification ' + new Date().toLocaleTimeString()
        )
    }

    public async getTaggableUsers(): Promise<GetGeneralListSuccessResult<UserTag>> {
        return this.handleGetListRequest(
            `${BASE_API_URL}/email/users`,
            'get taggable users ' + new Date().toLocaleTimeString(),
            {'Content-Type': 'application/json'}
        )
    }

    public async getTaggableUsersByGroup(groupId: number): Promise<GetGeneralListSuccessResult<UserTag>> {
        const data = JSON.stringify(groupId);
        return this.handlePostRequestReturningArray(
            `${BASE_API_URL}/email/group-users`,
            data,
            {'Content-Type': 'application/json'},
            'get taggable users by group ' + new Date().toLocaleTimeString()
        )
    }

    public async sendVoidedEmail(emailRequestDTO: EmailRequestDTO): Promise<GetGeneralSuccessResult> {
        const data = JSON.stringify(emailRequestDTO);
        const response: AxiosResponse = await axios({
            method: 'post',
            url: `${BASE_API_URL}/email/notify/proposal-voided`,
            data,
            headers: {
                'Content-Type': 'application/json'
            }
        })

        if (!response.data) return { success: false }

        try {
            return { success: true }
        } catch {
            return { success: false }
        }
    }
}